<template>
  <div>

    <div class="main">
      <router-view/>
    </div>
    <div class="footer">
      <el-menu
        :default-active="active"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#343c6d"
        text-color="#fff"
        active-text-color="#ffd04b">
<!--        <el-menu-item index="/"><i class="el-icon-house"></i><p>首页</p></el-menu-item>-->
        <el-menu-item
          :style="{width: (100/menus.length)+'%'}"
          v-for="(menu, index) in menus"
          :key="index"
          :index="'/' + menu.index">
          <i :class="menu.icon"></i>
          <p>{{ menu.label }}</p>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getFrameMenus} from "@/assets/js/consult";

export default {
  name: 'mainpage',
  data() {
    return {
      active: "/",
      menus: []
    }
  },
  computed: {
    ...mapState({
      student: state => state.user.student,
      admin: state => state.user.admin
    }),
  },
  created() {
    //获取学校信息(包含伪权限)
    this.getAdminMenu()
  },
  mounted() {

  },
  methods: {
    handleSelect(index, indexPath) {
      this.$router.push(index);
    },
    getAdminMenu() {
      let consult_SmartPavilion = this.admin.jsonSetting.consult_SmartPavilion
      let open_homepage = this.admin.jsonSetting.open_homepage
      this.menus = getFrameMenus(consult_SmartPavilion ,open_homepage)
      this.active = '/' + this.menus[0].index
    }
  }
}
</script>


<style scoped>
.el-menu--horizontal > .el-menu-item {
  line-height: 22px;
  text-align: center;
  padding: 8px 15px;
}

.el-menu-item [class^=el-icon-] {
  margin: 0;
}


</style>
